import {
    EDITOR_BOLD,
    EDITOR_ITALIC,
    EDITOR_FONT_SIZE,
    EDITOR_FONT_FAMILY,
    EDITOR_TEXT_COLOR,
} from '../constants/chatEditorOwn';

import {
    USER_SORTING_SELECT
} from '../constants/users';

import Registry from '../registry/index';

const settingsMiddleware = (store) => (next) => (action) => {
    if ([EDITOR_BOLD, EDITOR_ITALIC, EDITOR_FONT_SIZE, EDITOR_FONT_FAMILY, EDITOR_TEXT_COLOR, USER_SORTING_SELECT].indexOf(action.type) != -1) {
        /** @type Settings **/
        let settings = Registry.get('settings');

        switch(action.type) {
            case USER_SORTING_SELECT: settings.set('sortby', action.sorting); break;
            case EDITOR_BOLD: settings.set('bold', !settings.get('bold')); break;
            case EDITOR_ITALIC: settings.set('italic', !settings.get('italic')); break;
            case EDITOR_FONT_SIZE: settings.set('size', action.value); break;
            case EDITOR_FONT_FAMILY: settings.set('family', action.value); break;
            case EDITOR_TEXT_COLOR: settings.set('color', action.value); break;
        }
    }

    next(action);
};

export default settingsMiddleware;


// WEBPACK FOOTER //
// ./src/middleware/settings.js